import { type ReactNode } from 'react'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { useAuth } from './auth/AuthProvider'
import { Login } from './auth/Login'
import { Layout } from './layout/Layout'
import { Cruscotto } from './home/Cruscotto'
import { ElencoImpianti } from './impianti/ElencoImpianti'
import { DettaglioImpianto } from './impianti/DettaglioImpianto'
import { Dichiarazione } from './dichiarazione/Dichiarazione'
import { ElencoDichiarazioni } from './dichiarazione/ElencoDichiarazioni'
import { AccountEPermessi } from './gestione/AccountEPermessi'
import { ElencoAziende } from './aziende/ElencoAziende'
import { Scadenzario } from './scadenze/Scadenzario'
import { Registri } from './registri/Registri'
import { GestioneEmail } from './email/GestioneEmail'
import { AccountInvio } from './email/AccountInvio'
import { LogEmail } from './email/LogEmail'
import { ServiziProvider } from './servizi/ServiziProvider'
import { Guardia } from './servizi/ModuloDaAttivare'
import { Monitoraggio } from './green/Monitoraggio'
import { DettaglioGreen } from './green/DettaglioGreen'
import { Controllo } from './green/Controllo'
import { Configurazione } from './green/Configurazione'
import { LogAttivita } from './gestione/LogAttivita'
import { Credenziali } from './gestione/Credenziali'
import { GestioneServizi } from './servizi/GestioneServizi'
import { Assistenza, Funzionalita, Guide } from './aiuto/Aiuto'
import { PaginaInArrivo, PaginaNonTrovata } from './layout/Pagina'
import { partnerIdDaToken } from './lib/claims'

function RottaProtetta({ children }: { children: ReactNode }) {
  const { sessione, caricamento } = useAuth()
  const { idPartner } = useParams()
  if (caricamento) return null
  if (!sessione) return <Login />

  const mio = partnerIdDaToken(sessione.access_token)
  if (mio !== undefined && String(mio) !== idPartner) {
    return <Navigate to={`/cliente/${mio}/`} replace />
  }
  return <>{children}</>
}

function VaiAScadenzario() {
  const { idPartner } = useParams()
  return <Navigate to={`/cliente/${idPartner}/scadenzario`} replace />
}

export function Rotte() {
  return (
    <Routes>
      {/* "/cliente" (senza :idPartner) non fa mai match con la rotta protetta sotto: un
          <Navigate to="/cliente"> nudo finiva sempre sul catch-all "Pagina non trovata",
          anche per un anonimo che doveva solo vedere il login. RottaProtetta gestisce gia'
          questo caso da sola: senza sessione rende <Login/>, con sessione rimanda al
          /cliente/:idPartner/ del token (mio !== idPartner e' sempre vero qui, idPartner
          e' undefined in questa rotta) invece di passare per un redirect intermedio. */}
      <Route path="/" element={<RottaProtetta><Navigate to="/cliente" replace /></RottaProtetta>} />
      <Route
        path="/cliente/:idPartner/*"
        element={
          <RottaProtetta>
            <ServiziProvider>
              <Layout>
                <Routes>
                  <Route index element={<Cruscotto />} />
                  <Route path="aziende" element={<ElencoAziende />} />
                  <Route path="scadenzario" element={<Scadenzario />} />
                  <Route path="scadenza_registri" element={<Registri />} />
                  <Route
                    path="gestione-notifiche"
                    element={
                      <>
                        <AccountInvio />
                        <GestioneEmail />
                      </>
                    }
                  />
                  <Route path="log-notifiche" element={<LogEmail />} />
                  <Route path="account-e-permessi" element={<AccountEPermessi />} />
                  <Route path="impianti" element={<ElencoImpianti />} />
                  <Route path="dichiarazioni" element={<ElencoDichiarazioni />} />
                  <Route path="impianti/:idImpianto" element={<DettaglioImpianto />} />
                  <Route path="impianti/:idImpianto/dichiarazione/:anno/:periodo" element={<Dichiarazione />} />
                  {/* Stessi moduli delle voci di menu (layout/menu.ts). */}
                  <Route path="impianti-green" element={<Guardia modulo="monitoraggioEdistribuzione"><Monitoraggio /></Guardia>} />
                  <Route path="impianti-green/:idGreen" element={<Guardia modulo="monitoraggioEdistribuzione"><DettaglioGreen /></Guardia>} />
                  <Route path="alert-green" element={<Guardia modulo="alertEdistribuzione"><Controllo /></Guardia>} />
                  <Route path="green-configurazione" element={<Configurazione />} />
                  <Route path="credenziali-distributore" element={<Credenziali />} />
                  <Route path="log-attivita" element={<LogAttivita />} />
                  <Route path="servizi" element={<GestioneServizi />} />
                  {/* Lo scadenzario gestisce gia' le personalizzate: una seconda pagina sarebbe un doppione. */}
                  <Route path="scadenze-personalizzate" element={<VaiAScadenzario />} />
                  <Route
                    path="token-e-contratti"
                    element={
                      <PaginaInArrivo
                        titolo="Token e contratti"
                        descrizione="Saldo del portafoglio a token, ricariche, movimenti e contratto in corso."
                        dipende="Arriva con i pagamenti online: fino ad allora contratto e ricariche si gestiscono con noi."
                      />
                    }
                  />
                  <Route
                    path="portali-personalizzati"
                    element={
                      <Guardia modulo="portaliPersonalizzati">
                        <PaginaInArrivo
                          titolo="Portali personalizzati"
                          descrizione="Credenziali di altri portali scelti da te (ARERA, gestori di rete, altro), conservate cifrate insieme a quelle dei distributori."
                          dipende="Arriva insieme al prelievo automatico dai portali."
                        />
                      </Guardia>
                    }
                  />
                  <Route path="guide" element={<Guide />} />
                  <Route path="funzionalita" element={<Funzionalita />} />
                  <Route path="helpdesk" element={<Assistenza />} />
                  <Route path="*" element={<PaginaNonTrovata />} />
                </Routes>
              </Layout>
            </ServiziProvider>
          </RottaProtetta>
        }
      />
      <Route path="*" element={<p>Pagina non trovata</p>} />
    </Routes>
  )
}
